import { useTransition } from 'react-spring';
import { useReducedMotion } from '@wix/da-hooks/pkg/useReducedMotion';
import { SlideDirection } from '../types';
export default function useSlideAnimation(state) {
    const immediate = useReducedMotion();
    return useTransition(state.index, null, {
        from: transformFrom(state.direction),
        enter: {
            transform: 'translate3d(0%, 0, 0)'
        },
        leave: transformLeave(state.direction),
        immediate
    });
}
const translateTransform = (translateX)=>({
        transform: `translate3d(${translateX}, 0, 0)`
    });
const transformFrom = (direction)=>{
    switch(direction){
        case SlideDirection.LEFT:
            return translateTransform('-150%');
        case SlideDirection.RIGHT:
            return translateTransform('150%');
        default:
            return translateTransform('0%');
    }
};
const transformLeave = (direction)=>{
    const translateX = direction === SlideDirection.LEFT ? '150%' : '-150%';
    return translateTransform(translateX);
};

//# sourceMappingURL=useSlideAnimation.js.map